import React from 'react';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import PrestaGlobals from '../common/PrestaGlobals';
import AdminApi from './AdminApi';

/**
 * EA-446: create a new configurable product from the current product's state (same UCon script +
 * parameter layout, current shop). Shared parameter definitions are referenced, not cloned, so the
 * new product inherits the same shop-level values as the source (this system's model).
 */
const CreateProductForm: React.FC = () => {
    const [name, setName] = React.useState('');
    const [busy, setBusy] = React.useState(false);
    const [status, setStatus] = React.useState<string | null>(null);

    const handleCreate = async () => {
        if (!name.trim()) return;
        setBusy(true);
        setStatus(null);
        const res = await AdminApi.createProduct(PrestaGlobals.productId, name.trim());
        setBusy(false);
        if (res && 'success' in res && res.success) {
            setStatus(`Létrehozva piszkozatként: termék #${res.id_product} (inaktív, szkript #${res.id_configuration_script}). Aktiváld a Back Office-ban (Katalógus), hogy elérhető legyen.`);
            setName('');
        } else {
            setStatus('Hiba: ' + (res && 'error' in res ? res.error : 'ismeretlen'));
        }
    };

    return (
        <Accordion disableGutters sx={{ mt: 1 }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant="subtitle2">Új termék az aktuális állapotból</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>
                    Új konfigurálható terméket hoz létre az aktuális termék (#{PrestaGlobals.productId}) alapján:
                    ugyanaz a UCon szkript és paraméter-elrendezés, a jelenlegi bolthoz. <strong>Piszkozatként
                    (inaktívan)</strong> jön létre — a Back Office-ban aktiváld, ha kész. A megosztott paraméterek
                    értékeit a forrással közösen használja (a rendszer modellje szerint).
                </Typography>
                <Stack spacing={1}>
                    <TextField label="Új termék neve" size="small" value={name}
                        onChange={(e) => setName(e.target.value)} />
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Button variant="contained" size="small" disabled={!name.trim() || busy} onClick={handleCreate}>
                            {busy ? 'Létrehozás…' : 'Létrehozás'}
                        </Button>
                        {status && <Typography variant="caption" color="text.secondary">{status}</Typography>}
                    </Stack>
                </Stack>
            </AccordionDetails>
        </Accordion>
    );
};

export default CreateProductForm;
